import React from "react";
import { Phone, Check } from "lucide-react";
import Reveal from "../Reveal";
import { IMG, PHONE_DISPLAY, PHONE_TEL } from "../../../lib/site";

const POINTS = [
  "Juliana answers the phone and keeps you informed",
  "Tyler personally inspects, preps and coats every floor",
  "Tyler gives every estimate in person, on-site",
  "Premium industrial-grade materials only",
];

const MeetTyler = ({ showPhone = true, centered = false }) => (
  <section className="py-20 md:py-24 bg-zinc-950 border-y border-zinc-900" data-testid="meet-tyler-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 order-2 lg:order-1">
        <div className="relative">
          <img src={IMG.tylerFamily} alt="Tyler and Juliana, the family behind PRYME EPOXY" loading="lazy" className="w-full aspect-[4/3] object-cover border border-zinc-800" />
          <div className="absolute -bottom-5 -right-3 sm:right-6 bg-[#C69453] text-black px-5 py-3">
            <p className="font-heading font-bold text-lg leading-none">Owner Operated</p>
            <p className="text-xs uppercase tracking-widest mt-1">A Northern Arizona Family Business</p>
          </div>
        </div>
      </div>

      <div className={`lg:col-span-6 order-1 lg:order-2 ${centered ? "text-center" : "text-left"}`}>
        <Reveal>
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Meet Tyler &amp; Juliana</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2 leading-tight">
            The Family Behind Every PRYME Floor
          </h2>
          <p className="text-zinc-300 text-lg mt-5 leading-relaxed italic">
            &ldquo;We built PRYME EPOXY as a family. When you call, you'll talk to Juliana — she runs our
            schedule and keeps you informed every step of the way. And when it's time to prep your slab and
            walk your estimate, that's Tyler, on-site and hands-on, every single time.&rdquo;
          </p>
          <div className="mt-4">
            <p className="text-white font-bold text-lg">Tyler &amp; Juliana</p>
            <p className="text-[#C69453] text-xs uppercase tracking-widest font-semibold">Owners, PRYME EPOXY</p>
          </div>

          <ul className={`grid sm:grid-cols-2 gap-3 mt-7 ${centered ? "text-left max-w-xl mx-auto" : ""}`}>
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-2 text-zinc-300 text-sm">
                <Check className="w-5 h-5 text-[#C69453] shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <a href={PHONE_TEL} className={`${showPhone ? "inline-flex" : "hidden"} items-center gap-2 mt-8 bg-[#C69453] hover:bg-[#AE7F44] text-black font-bold px-6 py-3.5 transition-colors`}>
            <Phone className="w-5 h-5" />
            <span>Call Pryme: {PHONE_DISPLAY}</span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default MeetTyler;
